import React, { useEffect, useRef, useState } from 'react';
import theme from '@styles/theme';
import styled from '@emotion/styled';
import { ProgressBar } from '@components/commons';

interface ITimerBar {
  onClear: () => void;
  timeout?: number;
}

const PROGRESS_FREQUENCY = 20;
const TIME_FREQUENCY = 1000;
const DEFAULT_TIMEOUT = 10000;

const TimerBar = ({ onClear, timeout = DEFAULT_TIMEOUT }: ITimerBar) => {
  const [time, setTime] = useState<number>(timeout);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 0) {
          onClear();
          timerRef.current && clearInterval(timerRef.current);
        }

        return prevTime - PROGRESS_FREQUENCY;
      });
    }, PROGRESS_FREQUENCY);

    return () => {
      timerRef.current && clearInterval(timerRef.current);
    };
  }, []);

  return (
    <BarContainer>
      <div className="number">{Math.ceil(time / TIME_FREQUENCY)}</div>
      <ProgressBar
        size={100}
        value={(100 * time) / timeout}
        color={theme.colors.gray900}
      />
    </BarContainer>
  );
};

const BarContainer = styled.div`
  background-color: transparent;
  display: flex;
  justify-content: center;

  .number {
    position: absolute;
    margin-top: -20px;
    font-size: 1em;
    font-weight: 700;
  }
`;

export default TimerBar;
